import React from 'react';
import { BreadcrumbProps } from './types';
import { BreadcrumbContainer, BreadcrumbLink, CrumbText, Separator } from './Breadcrumbs.styles';
import { ellipsisText } from 'helpers/strings-functions';

const Breadcrumbs = ({ items = [], separator = '/', truncateName = true }: BreadcrumbProps) => {
  return (
    <BreadcrumbContainer aria-label="breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const key = index;

          const truncated = truncateName ? ellipsisText(item.label, 43) : item.label;

          return (
            <li key={key}>
              {isLast ? (
                <CrumbText aria-current="page">{truncated}</CrumbText>
              ) : (
                <BreadcrumbLink to={item.route}>{truncated}</BreadcrumbLink>
              )}
              {!isLast && <Separator aria-hidden="true">{separator}</Separator>}
            </li>
          );
        })}
      </ol>
    </BreadcrumbContainer>
  );
};

export default Breadcrumbs;
